import { Col, Row, Modal } from "react-bootstrap";
import { useLanguage, useToggle } from "hooks";
import CollapseList from "./CollapseList";
import Slice from "./Slice";

const SearchSideFilter = ({
  title,
  filters,
  CollapseProps,
  filtersFromParams,
  removeFilter,
  addFilter,
}) => {
  const language = useLanguage(); //language returned from useLanguage hook; it’s an object with current language key --> "value in current language";
  const [show, toggleShow] = useToggle();

  return (
    <div>
      <Row className="align-items-center mb-4 ">
        <Col xl={10} lg={10} md={10} sm={10} xs={10}>
          <h2 className="fw-medium text-primary"> {title} </h2>
        </Col>
        <Col
          xl={2}
          lg={2}
          md={2}
          sm={2}
          xs={2}
          className="d-flex justify-content-end d-block d-lg-none"
        >
          <button className="btn btn-outline-light4" onClick={toggleShow}>
            {language.filter}
          </button>
        </Col>
      </Row>

      <Row className="d-none d-lg-flex">
        <Col xs={12}>
          {filters.getAllFilters().map((item, index) => {
            let tester = false;
            for (let i = 0; i < item.values.length; i++) {
              if (item.values[i].books_count > 0) tester = true;
            }

            return (
              tester && (
                <CollapseList
                  key={index}
                  className="svg-fill-black mb-4 "
                  titleClasses="text-black"
                  title={item.name}
                  {...CollapseProps}
                >
                  <Slice
                    limit={3}
                    renderMore={
                      <h6 role="button" className="fw-normal text-center">
                        {language.more} ...
                      </h6>
                    }
                    renderLess={
                      <h6 role="button" className="fw-normal text-center">
                        {language.less} ...
                      </h6>
                    }
                  >
                    {item.values
                      .filter((subItem) =>
                        Object.entries(filtersFromParams.filters).length >
                          0 &&
                        Object.keys(filtersFromParams.filters).indexOf(
                          item.key
                        ) > -1
                          ? Object.entries(
                              filtersFromParams.filters[item.key]
                            )[0]
                            ? Object.entries(
                                filtersFromParams.filters[item.key]
                              )[0].indexOf(String(subItem.id)) > -1 ||
                              Object.entries(
                                filtersFromParams.filters[item.key]
                              )[0].indexOf(Number(subItem.id)) > -1
                            : true
                          : true
                      )
                      .filter((subItem) => subItem.books_count != 0)
                      .map((subItem, subIndex) => (
                        <div
                          key={subIndex}
                          role="button"
                          xs={12}
                          className={`${
                            Object.entries(filtersFromParams.filters).filter(
                              (f) => {
                                return (
                                  f[0] === item.key &&
                                  f[1]
                                    .map((r) => String(r))
                                    .includes(String(subItem.id))
                                );
                              }
                            ).length > 0
                              ? "chosen"
                              : ""
                          } list-item  mb-2`}
                          onClick={() => {
                            if (
                              Object.entries(filtersFromParams.filters).filter(
                                (f) => {
                                  return (
                                    f[0] === item.key &&
                                    f[1]
                                      .map((r) => String(r))
                                      .includes(String(subItem.id))
                                  );
                                }
                              ).length > 0
                            ) {
                              removeFilter({
                                filters: {
                                  [item.key]: [subItem.id],
                                },
                              });
                            } else {
                              addFilter({
                                filters: {
                                  [item.key]: [subItem.id],
                                },
                              });
                            }
                          }}
                        >
                          <div
                            key={subIndex}
                            role="button"
                            className="list-item d-flex justify-content-between align-items-center px-1 mb-2"
                          >
                            <h6 className="fw-normal px-2 ">{subItem.name}</h6>
                            <small className="number">
                              {subItem.books_count}
                            </small>
                          </div>
                        </div>
                      ))}
                  </Slice>
                </CollapseList>
              )
            );
          })}
        </Col>
      </Row>

      <Modal
        show={show}
        onHide={toggleShow}
        animation={true}
        fullscreen={true}
        centered
        className="bg-white "
      >
        <Modal.Header className="" closeButton>
          <Modal.Title className="col-10">{title}</Modal.Title>
        </Modal.Header>

        <Modal.Body className="vh-100 px-4 py-5 ">
          {filters.getAllFilters().map((item, index) => (
            <CollapseList
              key={index}
              title={item.name}
              className="svg-fill-black mb-4 "
              titleClasses="text-black"
            >
              <Row className="mx-2">
                {item.values.map((subItem, subIndex) => (
                  <Col
                    key={subIndex}
                    role="button"
                    xs={12}
                    className={`${
                      Object.entries(filtersFromParams.filters).filter((f) => {
                        return (
                          f[0] === item.key &&
                          f[1]
                            .map((r) => String(r))
                            .includes(String(subItem.id))
                        );
                      }).length > 0
                        ? "chosen"
                        : ""
                    } list-item  mb-2`}
                    onClick={() =>
                      filters.handleToggleFilterValue(item.key, subItem.id)
                    }
                  >
                    <span className="fw-normal px-2 ">{subItem.name}</span>
                  </Col>
                ))}
              </Row>
            </CollapseList>
          ))}
        </Modal.Body>

        <Modal.Footer className="bottom-0 position-fixed w-100 bg-white">
          <button className="btn btn-primary w-100" onClick={toggleShow}>
            {language.applyFilters}
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
export default SearchSideFilter;
